export default __webpack_public_path__ + "static/media/tick.877339a7.svg";